import styled from "styled-components";
import ButtonNormal from "./ButtonNormal";

const ButtonSmall = styled(ButtonNormal)`
    border-radius: 14px;
    padding: 5px 14px;
    height: 28px;
    background-color: #66ccff;
    color: #ffffff;
    font-size: 0.8rem;
    outline: none;

    :hover {
        background-color: #55aadd;
    }

    :disabled {
        color: #999999;
        background-color: #006666;
    }
`;

export default ButtonSmall;